import { Snackbar, Alert } from '@mui/material';
import { useUserStore } from '../../stores/userStore';

const EjectionNotification = () => {
  const ejectionStatus = useUserStore(state => state.ejectionStatus);
  const clearEjectionStatus = useUserStore(state => state.clearEjectionStatus);

  return (
    <Snackbar
      open={!!ejectionStatus}
      autoHideDuration={10000}
      onClose={clearEjectionStatus}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="error" onClose={clearEjectionStatus} sx={{ width: '100%' }}>
        Your account has been {ejectionStatus}. You have been logged out.
      </Alert>
    </Snackbar>
  );
};

export default EjectionNotification;
